<template lang="html">
  <div>
    <iframe id="iframeReport" name="iframeReport" style="height:0;width:0;"></iframe>
    <section ref="invoice" style="display:none;"  id="printableArea">
      <v-card class="py-1 px-3 card">
        <v-banner style="padding-left: 30px" class="subtitle" single-line >
          Report Card
        </v-banner>
        <v-row>
          <v-col> <h3>{{printData.name}} </h3></v-col>
        </v-row>
        <v-row>
          <v-col>Module Completed: {{printData.trainingRecordModules.length}}/{{printData.trainingRecordModules.length}} </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col v-for="(item, i) in printData.trainingRecordModules" :key="i" cols="6" sm="6" md="6">
            <v-row>
              <v-col>
                {{item.name}}: {{Number(item.percentage).toFixed(2)}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{item.score}}/{{item.totalQuestions}} correct
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </section>
  </div>
</template>

<script>

export default {
  name: 'OnlineClassList',
  props: ['printData'],
  components: {
  },
  data () {
    return {
      prtHtml: ''
    }
  },

  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // this.printInvoice()
  },
  methods: {
  }
}
</script>
<style scoped>
@media print {
  #printableArea,
  #printableArea * {
    visibility: visible;
  }
  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }
  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
